function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Platform, Pressable, Switch } from "react-native";
import { Text } from "./Text";
import { View } from "./View";
import { useI18n } from "../lib/i18n";
import { useTheme } from "../styles";
/**
 * A "switch" UI element that allows the user to input an on/off value.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-114}
 */ export function SwitchInput(props) {
    var theme = useTheme().theme;
    var $t = useI18n().$t;
    return /*#__PURE__*/ _jsxs(Pressable, {
        style: {
            flexDirection: 'row',
            alignItems: 'center',
            gap: 8,
            opacity: props.disabled ? 0.5 : 1
        },
        accessible: true,
        role: "switch",
        "aria-label": props['aria-label'],
        "aria-checked": !!props.value,
        "aria-disabled": !!props.disabled,
        onAccessibilityTap: function() {
            var _props_onChangeValue;
            (_props_onChangeValue = props.onChangeValue) === null || _props_onChangeValue === void 0 ? void 0 : _props_onChangeValue.call(props, !props.value);
        },
        onPress: function() {
            var _props_onChangeValue;
            (_props_onChangeValue = props.onChangeValue) === null || _props_onChangeValue === void 0 ? void 0 : _props_onChangeValue.call(props, !props.value);
        },
        children: [
            props.showOnOff ? /*#__PURE__*/ _jsx(Text, {
                role: "none",
                text: props.value ? $t({
                    id: 'SwitchInput_onLabel',
                    defaultMessage: 'On'
                }) : $t({
                    id: 'SwitchInput_offLabel',
                    defaultMessage: 'Off'
                }),
                color: theme.color.gray400
            }) : null,
            /*#__PURE__*/ _jsx(View, {
                style: {
                    backgroundColor: props.value ? 'white' : theme.color.gray700,
                    borderWidth: 2,
                    paddingHorizontal: 1,
                    borderRadius: 20,
                    borderColor: props.value ? theme.color.primary100 : theme.color.gray600
                },
                "aria-hidden": true,
                children: /*#__PURE__*/ _jsx(Switch, _object_spread_props(_object_spread({
                    value: !!props.value,
                    thumbColor: props.value ? theme.color.primary100 : 'white',
                    trackColor: {
                        false: theme.color.gray700,
                        true: 'white'
                    },
                    onValueChange: props.onChangeValue,
                    ios_backgroundColor: "white"
                }, Platform.OS === 'web' ? {
                    activeThumbColor: theme.color.primary100
                } : undefined), {
                    testID: props.testID
                }))
            })
        ]
    });
}
